/* eslint-disable */
import { Component, EventEmitter, forwardRef, Input, OnInit, Output, ChangeDetectionStrategy } from "@angular/core";
import { Subject } from "rxjs";
import { debounceTime, takeUntil } from "rxjs/operators";
import { IWebInstallningHandler } from "~app/common/models/webInstallning-models";
import { IMapListWidgetFilter } from "~app/features/planera/model/IMapListWidgetFilter";
import { IMapComponent } from "../../../map.models";
import { IMapSettings } from "../../../map.settings";
import { IMapUserSettingsMap } from "../../../map.user.settings";
import { LayerListComponent } from "../../widgets/layer-list/layer-list.component";
import { ILayerSettings } from "../../widgets/layer-list/models/layer-list.models";
import { LayerVisibility } from "../../widgets/layer-list/models/layer-visibility.model";
import { MapBaseSubComponent } from "../map-base-sub-component/map-base-sub.component";

@Component({
    selector: "rask-map-layers",
    templateUrl: "./map-layers.component.html",
    styleUrls: ["./map-layers.component.scss"],
    providers: [{ provide: MapBaseSubComponent, useExisting: forwardRef(() => MapLayersComponent) }],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [LayerListComponent]
})
export class MapLayersComponent extends MapBaseSubComponent implements OnInit {
    @Input("refresh") refreshMapSettings: Subject<IMapSettings>;
    @Output() visibilityEvent = new EventEmitter<LayerVisibility>();
    layersLoaded = false;
    widgetId = "map-layers";
    buttons = [{
        iconClass: "fa-layer-group",
        tooltipText: "Lager",
        visible: () => this.isReady(),
        widgetId: this.widgetId
    }];
    mapsettings: IMapSettings;
    view: any;
    userMapSettings: IMapUserSettingsMap;
    filter: IWebInstallningHandler<IMapListWidgetFilter>;
    settings: ILayerSettings;
    map: IMapComponent;
    v3: boolean;

    isReady() {
        return true;
    }

    onInit(view, draw) {
        this.view = view;
    }

    preInit(mapsettings: IMapSettings) {
        this.mapsettings = mapsettings;

        if (this.refreshMapSettings) {
            this.refreshMapSettings
                .pipe(debounceTime(100))
                .pipe(takeUntil(this.destroy$))
                .subscribe((x) => {
                    this.mapsettings = JSON.parse(JSON.stringify(x));
                });
        }
    }

    ngOnInit(): void {
        // Behövs för arv
    }

    onVisibilityChanged($event) {
        this.visibilityEvent.emit($event);
    }
}
